<script lang="ts">
    import Widget from "./components/Widget.svelte";
    import DevInfo from "./components/DevInfo.svelte";
    import type {Source} from "./@types/recommendation";
    import {mediaQueries} from "./utils/defaults";
    import MediaQuery from "./utils/MediaQuery.svelte";
    import {platform} from "./store/store";
    import {getBCCurrentCurrency, getBigcommerceCurrenciesRates, setBCSiteCurrency} from "./utils/getBCCurrentCurrency";
    import {printAppPoweredLog} from "./utils/appLogs";


    export let imgRatio: string;
    export let layout: string;
    export let maxSuggest: number;
    export let title: string;
    export let sources: Source[];
    export let productsPerPage: number;
    export let productsPerMobile: number;
    export let target: HTMLElement | ShadowRoot
    export let collections: string[];
    export let productsIds: string;
    export let fixedImageSize: string;
    export let onHoverCarousel: boolean
    export let dev: boolean;
    export let addToCart: boolean;

    printAppPoweredLog();

    if (!dev && $platform === "BigCommerce") {
        const BCCurrency = getBCCurrentCurrency();
        if (BCCurrency) {
            setBCSiteCurrency(BCCurrency);
            getBigcommerceCurrenciesRates()
        }
    }

</script>

{#each mediaQueries as mediaQuery}
    <MediaQuery query={mediaQuery.query} let:matches>
        {#if matches}
            {#if dev}
                <DevInfo/>
            {/if}
            <Widget productsPerPage={productsPerPage} imgRatio={imgRatio} layout={layout} maxSuggest={maxSuggest}
                    target={target} collections={collections} title={title} sources={sources} fixedImageSize={fixedImageSize}
                    currentDevice={mediaQuery.device} productsPerMobile={productsPerMobile} productsIds={productsIds}
                    onHoverCarousel={onHoverCarousel} dev={dev} addToCart={addToCart}
            />
        {/if}
    </MediaQuery>
{/each}